import { StateCreator } from 'zustand';

import { ManagingCompanySlice } from './types';

const managingCompanySlice: StateCreator<ManagingCompanySlice> = (set) => ({
  company: undefined,
  setCompany(company) {
    set({ company });
  },
});

export default managingCompanySlice;
